import { Add, FileCopy, Search, Visibility, VisibilityOff } from "@mui/icons-material";
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import { Affix, Col, List, Row } from "antd";
import { useState } from "react";
import { Constant } from "../../../constant";
import BatteryGPS from "./BatteryGPS";

const Icons = {
  MOTO: TwoWheelerIcon,
};

export default function ListGps({ mapRef, gpsDataList, retourModal, openPetitDetail, openAjoutModal}) {
  const [list, setList] = useState(true);

  function SelectIcon({ iconName }) {
      const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent /> : null;
  }

  function getElapsedTime(serverTime) {
    if (serverTime === null || serverTime === undefined) return null;
      const now = new Date();
      const last = new Date(serverTime);
      const diffMs = now - last;

      const diffSec = Math.floor(diffMs / 1000);

      // 🔥 moins d'une minute → on ne remplace pas le status
      if (diffSec < 60) return null;

      const minutes = Math.floor(diffSec / 60);
      if (minutes < 60) return `il y a ${minutes} minute${minutes > 1 ? "s" : ""}`;

      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `il y a ${hours} heure${hours > 1 ? "s" : ""}`;

      const days = Math.floor(hours / 24);
      if (days < 30) return `il y a ${days} jour${days > 1 ? "s" : ""}`;

      const months = Math.floor(days / 30);
      return `il y a ${months} mois`;
  }

  return (
    <Affix offsetTop={5}
      style={{
        position: "absolute",
        zIndex: 1000,
          top: "10px",
          left: "10px",
          zIndex: 1000,
      }}
      >
      <div
        style={{
          width: list ? 350 : 80,
          backgroundColor: "white",
          borderLeft: "2px solid " + Constant.couleur.primary,
          borderRight: "2px solid " + Constant.couleur.primary,
          borderBottom: "2px solid " + Constant.couleur.primary,
        }}
      >
        <div style={{backgroundColor: Constant.couleur.primary, paddingTop: 5, paddingBottom: 5}}>
          <Row gutter={[16,16]}>
            <Col xs={list ? 6 : 24}>
              <div onClick={(e)=> setList(!list)} style={{textAlign: 'center', color: 'white'}}>
                {list ? <VisibilityOff/> : <Visibility/>}
                <p>{list ? Constant.fr.Cacher : Constant.fr.Afficher}</p>
              </div>
            </Col>
            {list &&
              <Col xs={6} style={{borderLeft: "1px solid white"}}>
                <div onClick={(e)=> setList(!list)} style={{textAlign: 'center', color: 'white'}}>
                  <FileCopy/>
                  <p>{Constant.fr.Rapports}</p>
                </div>
              </Col>
            }
            {list &&
              <Col xs={6} style={{borderLeft: "1px solid white"}}>
                <div onClick={(e)=> setList(!list)} style={{textAlign: 'center', color: 'white'}}>
                  <Search/>
                  <p>{Constant.fr.Filtrer}</p>
                </div>
              </Col>
            }
            {list &&
              <Col xs={6} style={{borderLeft: "1px solid white"}}>
                <div onClick={(e)=> openAjoutModal({})} style={{textAlign: 'center', color: 'white'}}>
                  <Add/>
                  <p>{Constant.fr.Ajouter}</p>
                </div>
              </Col>
            }
          </Row>
        </div>
        {list &&
          <List
            itemLayout="horizontal"
            dataSource={gpsDataList}
            style={{maxHeight: window.screen.height - 500, overflowY: "auto"}}
            renderItem={(item, index) => {
              let status = Constant.statusGps.find(a=>a.label === item.status)
              let typeVehiculeGps = Constant.typeVehiculeGps.find(a=>a.label === item.gps.type)
              if(status === null || status === undefined) {
                status = Constant.statusGps.find(a=>a.label === Constant.offline)
              }
              return <List.Item style={{margin: 0, paddingLeft: 10, paddingRight: 10}} onClick={(e)=>openPetitDetail(item)}>
                <List.Item.Meta
                  avatar={<div style={{backgroundColor: Constant.couleur.primary, borderRadius: 35, height: 35, width: 35, color: 'white', alignContent: 'center', textAlign: 'center'}}><SelectIcon iconName={typeVehiculeGps.value} /></div>}
                  title={
                    <Row gutter={[16, 16]}>
                      <Col xs={20}>
                        <div style={{margin: 0, color: Constant.couleur.primary}}>
                          {item.gps.nom}
                        </div>
                      </Col>
                      <Col xs={4} style={{paddingRight: 10}}>
                        {item.batteryLevel !== undefined && <BatteryGPS percent={item.batteryLevel} charging={false} />}
                      </Col>
                    </Row>
                }
                  description={<p style={{fontSize: 12, marginTop: -8}}>{item.gps.contact}-<strong style={{color: getElapsedTime(item.serverTime) ? "red" : status.color}}>{getElapsedTime(item.serverTime) ?? status.value}</strong></p>}
                />
              </List.Item>
            }}
          />
        }

        
      </div>
    </Affix>
  );
}